"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateTimeOffCreateHalfDayOverShiftMutation = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const timeoffCreateHalfDayOverShiftMutation = (0, graphql_tag_1.default) `
  mutation TimeOffCreateHalfDayOverShiftMutation(
    $user: ID!
    $shift: ID!
    $category: ID!
    $note: String
    $attachments: [ID!]
    $atTheStartOfShift: Boolean
  ) {
    timeOffCreateHalfDayOverShift(
      user: $user
      shift: $shift
      category: $category
      note: $note
      attachments: $attachments
      atTheStartOfShift: $atTheStartOfShift
    ) {
      id
    }
  }
`;
const mutateTimeOffCreateHalfDayOverShiftMutation = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(timeoffCreateHalfDayOverShiftMutation, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.timeOffCreateHalfDayOverShift;
};
exports.mutateTimeOffCreateHalfDayOverShiftMutation = mutateTimeOffCreateHalfDayOverShiftMutation;
